<template>
  <button-share v-tooltip="'Copiar URL'" @click="copyAndToast" aria-label="Copiar URL">
    <i class="fas fa-link" aria-hidden="true"></i>
  </button-share>
</template>

<script>
import ButtonShare from './ButtonShare'

export default {
  components: {
    ButtonShare
  },

  methods: {
    copyURL() {
      return new Promise((resolve, reject) => {
        if (!window.getSelection) {
          reject(new Error('Please copy the URL from the location bar.'))
        }

        const dummy = document.createElement('p')
        dummy.textContent = window.location.href
        document.body.appendChild(dummy)

        const range = document.createRange()
        range.setStartBefore(dummy)
        range.setEndAfter(dummy)

        const selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)

        document.execCommand('copy')
        document.body.removeChild(dummy)

        resolve()
      })
    },

    copyAndToast() {
      this.copyURL().then(() => {
        this.$toast.open('Copiado!')
      }).catch(() => {
        this.$toast.open({
          type: 'default',
          message: 'Copie o URL da barra de localização.'
        })
      })
    }
  },
}
</script>
